import { cultivationDataListView, type CultivationDataView } from './cultivation_data_view.js';
import { fertilizerApplicationListView, type FertilizerApplicationView } from './fertilizer_application_view.js';
import { fertilizerProductListView, type FertilizerProductView } from './fertilizer_product_view.js';
import { livestockInventoryListView, type LivestockInventoryView } from './livestock_inventory_view.js';
import {
    organicFertilizerDeliveryListView,
    type OrganicFertilizerDeliveryView,
} from './organic_fertilizer_delivery_view.js';
import { parcelListView, type ParcelView } from './parcel_view.js';
import { previousYearListView, type PreviousYearView } from './previous_year_view.js';
import { soilSampleListView, type SoilSampleView } from './soil_sample_view.js';
import { yieldSeriesListView, type YieldSeriesView } from './yield_series_view.js';

/**
 * The screen of every area of a Düngejahr that has more than a list.
 *
 * One object rather than one parameter per area: the route passes it, and the heading, the lead,
 * the breadcrumb and the body of the year page all read it, so another area with screens of its
 * own adds a key instead of an argument to every signature.
 */
export interface IAreaViews {
    parcel: ParcelView;
    soilSample: SoilSampleView;
    fertilizerProduct: FertilizerProductView;
    previousYear: PreviousYearView;
    yieldSeries: YieldSeriesView;
    cultivationData: CultivationDataView;
    fertilizerApplication: FertilizerApplicationView;
    organicFertilizerDelivery: OrganicFertilizerDeliveryView;
    livestockInventory: LivestockInventoryView;
}

/** Every area on its list, which is where a route that names no screen of an area opens it. */
export const listAreaViews: IAreaViews = {
    parcel: parcelListView,
    soilSample: soilSampleListView,
    fertilizerProduct: fertilizerProductListView,
    previousYear: previousYearListView,
    yieldSeries: yieldSeriesListView,
    cultivationData: cultivationDataListView,
    fertilizerApplication: fertilizerApplicationListView,
    organicFertilizerDelivery: organicFertilizerDeliveryListView,
    livestockInventory: livestockInventoryListView,
};
